import VeriffIdentityVerification from './VeriffIdentityVerification'

export default VeriffIdentityVerification